// extracted by mini-css-extract-plugin
module.exports = {"iconInclude":"TextWidget_iconInclude__3aeNY","inputIcon":"TextWidget_inputIcon__2QUxW"};